import { DropDown } from "../DropDown/DropDown.tsx";
import { formatDate } from "../Utils/formatDate.ts";
import { CalendarDatePicker } from "./CalendarDatePicker.tsx";

export function DateInput({
  value,
  onChange,
}: {
  value: Date;
  onChange: (date: Date) => void;
}) {
  return (
    <DropDown
      activator={
        <div className={"w-full"}>
          <p
            className={
              "border p-2 rounded-lg w-full min-h-[42px] border-slate-200 bg-slate-100 text-left"
            }
          >
            {formatDate(value)}
          </p>
        </div>
      }
    >
      <CalendarDatePicker selectedDate={value} onChange={onChange} />
    </DropDown>
  );
}
